import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const postAddressAutocomplete: DocumentNode = gql`
  query PostAddressAutocomplete($input: String!, $latitude: Float!, $longitude: Float!) {
    postAddressAutocomplete(input: { input: $input, locationBias: { circle: { center: { latitude: $latitude, longitude: $longitude }, radius: 10 } } }) {
      suggestions {
        placePrediction {
          placeId
          structuredFormat {
            mainText {
              text
            }
            secondaryText {
              text
            }
          }
        }
      }
    }
  }
`

export default postAddressAutocomplete
